// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6ElLm","easy":"Header_easy__pngp4","hard":"Header_hard__gZU98"};